import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IProfileMiniEpgChannelsParams } from '../../../entity/interface/iEntitlements';
export interface IGetProfileMiniEpgChannelsUseCase {
    execute(
        apiKey: string,
        username: string,
        profile: string,
        query: IProfileMiniEpgChannelsParams,
        token: string
    ): Promise<any>;
}

export class GetProfileMiniEpgChannelsUseCase implements IGetProfileMiniEpgChannelsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getProfileMiniEpgChannelsRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        username: string,
        profile: string,
        query: IProfileMiniEpgChannelsParams,
        token: string
    ): Promise<any> {
        const response = await this.getProfileMiniEpgChannelsRepository.getProfileMiniEpgChannels(
            apiKey,
            username,
            profile,
            query,
            token
        );
        return response.data.ids || [];
    }
}
